import './LoadingSkeleton.css';

interface LoadingSkeletonProps {
  variant?: 'chart' | 'chart-large' | 'text';
}

export function LoadingSkeleton({ variant = 'text' }: LoadingSkeletonProps) {
  return <div className={`LoadingSkeleton LoadingSkeleton--${variant}`} />;
}
